import api from './api';

export interface CarteraOperacion {
  numOperacion: number;
  codigoOperacion: string | null;
  activo: string | null;
  costeInversion: number | null;
  fechaAdquisicion: string | null;
  ticketsEmitidos: number | null;
  valorInicialTicket: number | null;
  fechaEmision: string | null;
  fechaRevalorizacionContable: string | null;
  valorContableAntes: number | null;
  valorContableDespues: number | null;
  porcentajeEmision: number | null;
  porcentajeActual: number | null;
  coefRevalorizacion: number | null;
  coefRevalorizacionAcc: number | null;
}

export interface CarteraTrimestre {
  label: string;
  fecha: string;
  numOperacion: number | null;
  porcentajeTickets: (number | null)[];
}

export interface CarteraResponse {
  operaciones: CarteraOperacion[];
  trimestres: CarteraTrimestre[];
}

export const carteraService = {
  getCartera: () => api.get<CarteraResponse>('/cartera'),
};
